import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import PatentSearchPage from './components/pages/PatentSearchPage';
import PatentResultsPage from './components/pages/PatentResultsPage';
import PatentDetailPage from './components/pages/PatentDetailPage';
import SearchHistoryPage from './components/pages/SearchHistoryPage';
import AnalyzePage from './components/pages/AnalyzePage';
import AnalyzeResultsPage from './components/pages/AnalyzeResultsPage';
import ReviewPage from './components/pages/ReviewPage';
import { APP_CONFIG } from './configs/config';

function AppContent() {
  const ExternalRedirect = ({ url }) => {
    React.useEffect(() => {
      window.location.replace(url);
    }, [url]);
    return null;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900 flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<PatentSearchPage />} />
          <Route path="/plain" element={<PatentSearchPage />} />
          <Route path="/search" element={<PatentResultsPage />} />
          <Route path="/patent" element={<PatentDetailPage />} />
          <Route path="/analyze" element={<AnalyzePage />} />
          <Route path="/analyze/results" element={<AnalyzeResultsPage />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/history" element={<SearchHistoryPage />} />
          <Route path="*" element={<ExternalRedirect url={APP_CONFIG.MAIN_WEBSITE_ORIGIN} />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

